import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import Seo from '../components/Seo';
import './NewsletterPage.css';
const NewsletterPage = () => {
    const { t } = useTranslation();
    const [email, setEmail] = useState('');
    const [status, setStatus] = useState('idle');
    const [message, setMessage] = useState('');
    const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    const handleSubscribe = async () => {
        if (!isValidEmail)
            return;
        setStatus('loading');
        try {
            const res = await fetch(`https://api.orcatec.net/newsletter/setNewsletter.php?email=${encodeURIComponent(email)}`);
            if (res.ok) {
                setStatus('success');
                setMessage(t('newsletter.subscribeSuccess', 'Successfully subscribed! Please check your email.'));
                setEmail('');
            }
            else {
                throw new Error();
            }
        }
        catch {
            setStatus('error');
            setMessage(t('newsletter.subscribeError', 'An error occurred. Please try again later.'));
        }
    };
    const handleUnsubscribe = async () => {
        if (!isValidEmail)
            return;
        setStatus('loading');
        try {
            const res = await fetch(`https://api.orcatec.net/newsletter/unsetNewsletter.php?email=${encodeURIComponent(email)}`);
            if (res.ok) {
                setStatus('success');
                setMessage(t('newsletter.unsubscribeSuccess', 'Successfully unsubscribed.'));
                setEmail('');
            }
            else {
                throw new Error();
            }
        }
        catch {
            setStatus('error');
            setMessage(t('newsletter.unsubscribeError', 'An error occurred. Please try again later.'));
        }
    };
    return (_jsxs("div", { className: "newsletter-page", children: [_jsx(Seo, { title: t('seo.newsletter.title', 'Newsletter'), description: t('seo.newsletter.description', 'Erhalte Updates zu neuen Garmin Watchfaces, Funktionen und Aktionen von TitanicTurtle.'), canonicalPath: "/newsletter" }), _jsxs("div", { className: "newsletter-container", children: [_jsx(motion.h1, { className: "newsletter-title", initial: { opacity: 0, y: -20 }, animate: { opacity: 1, y: 0 }, transition: { duration: 0.5 }, children: t('newsletter.title', 'Newsletter') }), _jsx("p", { className: "newsletter-description", children: t('newsletter.description', 'Subscribe to receive updates about new watchfaces, features, and promotions.') }), _jsx("p", { className: "newsletter-frequency-hint", children: t('newsletter.frequencyHint', 'Roughly one email every two months. You can unsubscribe at any time.') }), _jsxs(motion.div, { className: "newsletter-form", initial: { opacity: 0, y: 20 }, animate: { opacity: 1, y: 0 }, transition: { delay: 0.2, duration: 0.5 }, children: [_jsx("input", { type: "email", className: "newsletter-input", placeholder: t('newsletter.emailPlaceholder', 'Your email address'), value: email, onChange: (e) => { setEmail(e.target.value); setStatus('idle'); setMessage(''); } }), _jsxs("div", { className: "newsletter-actions", children: [_jsx("button", { className: "newsletter-btn btn-subscribe", onClick: handleSubscribe, disabled: !isValidEmail || status === 'loading', children: status === 'loading' ? '...' : t('newsletter.subscribe', 'Subscribe') }), _jsx("button", { className: "newsletter-btn btn-unsubscribe", onClick: handleUnsubscribe, disabled: !isValidEmail || status === 'loading', children: t('newsletter.unsubscribe', 'Unsubscribe') })] }), message && (_jsx("div", { className: `newsletter-message ${status}`, children: message }))] })] })] }));
};
export default NewsletterPage;
